export type TStatusCodes = 404 | 401 | 400 | 403 | 500 | number

export const errorTitleMapper: Record<TStatusCodes, string> = {
  404: 'متأسفانه صفحه مورد نظر پیدا نشد!',
  401: '',
  400: '',
  403: 'متأسفانه شما اجازه ورود ندارید!',
  500: 'ارتباط با سرور قطع است!',
}
export const errorDescMapper: Record<TStatusCodes, string> = {
  404: 'لطفا آدرس را دوباره بررسی کنید و یا به صفحه قبل برگردید.',
  401: '',
  400: '',
  403: 'در صورتی که از VPN استفاده می‌کنید، آنرا خاموش کنید و مجددا به صفحه وارد شوید و در غیر این صورت با پشتیبانی تماس بگیرید',
  500: 'در حال حاضر ارتباط با سرور برقرار نشده است. لطفا بعد از چند دقیقه مجددا وارد شوید.',
}
